import { U21Chip } from 'app/shared/u21-ui/components/display/U21Chip';

export const U21BetaFeatureLabel = () => {
  return (
    <U21Chip color="info" rounded>
      Beta
    </U21Chip>
  );
};
